import LinesGraph from './components/LinesGraph';

export default LinesGraph;
